import { EXCLUDED_INVESTOR_TEMPLATE_HEADERS, organizationHeaderMap } from './generic-data';

function generateHeaders(orgType: string) {
  let headerMap = organizationHeaderMap[orgType];

  return Object.keys(headerMap)
    .filter((header: string) => {
      return !EXCLUDED_INVESTOR_TEMPLATE_HEADERS.find((ex) => ex === header);
    })
    .reduce((acc, key) => {
      return `${acc}${headerMap[key]},`;
    }, '')
    .slice(0, -1);
}

const ESEK = `"Fylles inn dersom seksjonseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
${generateHeaders('ESEK')}
,,"Seksjons1","Eier","eier1@mailinator.com",210975,123456789,"Storgata 2", 1387, Oslo,Norge,,,,,
,,"Seksjons2","Eier","eier2@mailinator.com",121254,132456789,"Bodøgata 13", 8001, Bodø,Norge,,,,
"Selskap AS",259875361,"Representant","Person","representant@mailinator.com",,162345987,"Torvet 58", 0173, Oslo,,,,,,ja`;

const BRL = `"Fylles inn dersom andelseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
${generateHeaders('BRL')}
,,"Andels1","Eier","eier1@mailinator.com",210975,123456789,,"Storgata 2", 1387, Oslo,Norge,,,,
,,"Andels2","Eier","eier2@mailinator.com",121254,132456789,,"Bodøgata 13", 8001, Bodø,Norge,,,,
,,"Andels3","Eier","eier3@mailinator.com",050786,162345987,,"Torvet 58", 0173, Oslo,,,,,`;

const FLI = `"Fylles inn dersom medlemet er en organisasjon",,"Opplysinger på personlig medlem eller kontaktperson",,,,,,,
${generateHeaders('FLI')}
,,"Medlem1","Medlemsen","medlem1@mailinator.com",210975,0897,123456789,"Storgata 2", 1387, Oslo,Norge,,
,,"Medlem2","Medlemsen","medlem2@mailinator.com",121254,5421,132456789,"Bodøgata 13", 8001, Bodø,Norge,,,
"Selskap AS",259875361,"Representant1","Person","representant@mailinator.com",,,162345987,"Torvet 58", 0173, Oslo,Norge,
,,"Representant2","Person","representant2@mailinator.com",,,,,,,,,ja`;

const AS = `"Fylles inn dersom eier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,,,
${generateHeaders('AS')}
"Selskap AS",256123985,"Representant1","Person","representant1@mailinator.com",,,123456789,"Storgata 2", 1387, Oslo,Norge,,,,
,,"Aksje","Eier","eier@mailinator.com",121254,32221,132456789,"Bodøgata 13",8001, Bodø,Norge,,,,,
"Selskap2 AS",259875361,"Representant2","Person","representant2@mailinator.com",,,162345987,"Torvet 58",0173,Oslo,,,,,
,,"Representant3","Person","representant3@mailinator.com",,,,,,,,,,,ja`;

export const entityExamples = {
  ESEK,
  BRL,
  FLI,
  NIF: FLI,
  BA: FLI,
  SA: FLI,
  STI: FLI,
  FKF: FLI,
  KF: FLI,
  IKS: FLI,
  IKSR: FLI,
  SBSTI: FLI,
  ANS: FLI,
  DA: FLI,
  SPA: FLI,
  AS,
  ASA: AS,
};
